import TenantRoutes from "@/router/operator/tenant";

const OperatorRoutes = [
    {
        path: '',
        name: 'operator-index',
        component: () => import("@/components/operator/tenant/list.vue"),
    },
    {
        path: 'feature-billing',
        name: 'feature-billing',
        component: () => import("@/components/operator/feature-billing/index.vue"),
    },
    {
        path: 'feature-usage',
        name: 'feature-usage',
        component: () => import("@/components/operator/feature-usage/index.vue"),
    },
    {
        path: 'mcp-usage',
        name: 'operator-mcp-usage',
        component: () => import("@/components/operator/mcp-usage/index.vue"),
    },
    {
        path: 'invoice-recognition',
        name: 'operator-invoice-recognition',
        component: () => import("@/components/operator/invoice-recognition/index.vue"),
    },
    {
        path: 'ai-llm',
        name: 'operator-ai-llm',
        component: () => import("@/components/operator/ai-llm/index.vue"),
    },
    {
        path: 'invoice-export-log',
        name: 'operator-invoice-export-log',
        component: () => import("@/components/operator/invoice-export-log/index.vue"),
    },
    {
        path: 'bank-statement-fixtures',
        name: 'operator-bank-statement-fixtures',
        component: () => import("@/components/operator/bank-statement-fixtures/index.vue"),
    },
    {
        path: 'holiday-settings',
        name: 'operator-holiday-settings',
        component: () => import("@/components/operator/holiday-settings/index.vue"),
    },
    {
        path: 'einvoice-acceptance',
        name: 'operator-einvoice-acceptance',
        component: () => import("@/components/operator/einvoice-acceptance/index.vue"),
    },
    {
        path: 'tenant',
        name: 'tenant',
        component: () => import("@/components/operator/tenant/index.vue"),
        children: TenantRoutes
    },
];
export default OperatorRoutes
